export const UPDATE_SESSION_FLOW_FILTER = 'UPDATE_SESSION_FLOW_FILTER';
export const SESSION_FLOW_LOADED = 'SESSION_FLOW_LOADED';



// WEBPACK FOOTER //
// ./src/data/redux/session_flow_details/actiontypes.js